import * as React from "react";
import './styles/Services.css';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { CardActionArea, CardActions, Grid, Tooltip } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { Box } from "@mui/material";
import useMediaQuery from '@mui/material/useMediaQuery';
// import Carousel from "react-multi-carousel";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
import './styles/slickSlider.css';
// import "react-multi-carousel/lib/styles.css";
import rightarrow from "../../../../assets/icons/right-arrow-blue-icon.svg";
import leftarrow from "../../../../assets/icons/left-arrow-blue-icon.svg";
import location from '../../../../assets/icons/location-dot.svg';
import calendar from '../../../../assets/icons/calendar-days.svg';
import { useNavigate } from "react-router-dom";
import { useState, useEffect  } from "react";
import { width } from "@mui/system";

function useWidth() {
  const theme = useTheme();
  const keys = [...theme.breakpoints.keys].reverse();
  return (
    keys.reduce((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null) || 'xs'
  );
}
const Events = () => {

  
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [window.innerWidth]);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const[currentPage, setCurrentPage] =useState();
  const [currentSlide, setCurrentSlide] = useState(0);

  const remainingMonths = (data) => {
    // const currentDate = new Date();
    
    // const remainingMonthsData = data.filter(event => {
    //   const eventLastDate = new Date(event.date.match(/\b\w+\b\s\d+,\s\d{4}/)[0]);
    //   return eventLastDate > currentDate;
    // });
    
    // const monthsTextFormat = Object.keys(remainingMonthsData.reduce((acc, event) => {
    //   acc[event.month] = true;
    //   return acc;
    // }, {})).map(month => {
    //   const monthIndex = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].indexOf(month);
    //   return monthIndex !== -1 ? ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][monthIndex] : null;
    // }).filter(month => month !== null);
    const months = {
      "January": 0,
      "February": 1,
      "March": 2,
      "April": 3,
      "May": 4,
      "June": 5,
      "July": 6,
      "August": 7,
      "September": 8,
      "October": 9,
      "November": 10,
      "December": 11
    };
  
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();  // getMonth() returns month index (0 for January, 1 for February, etc.)
    const currentDay = currentDate.getDate();
  
    const remainingMonthsData = data.filter(event => {
      const eventMonth = months[event.month];
      const eventDay = event.lastDate;
  
      if (eventMonth > currentMonth) {
        return true;
      }
  
      if (eventMonth === currentMonth && eventDay >= currentDay) {
        return true;
      }
  
      return false;
    });
   
    return remainingMonthsData;
    }
    

  const servicesCard = [
  {
    title: "Governor’s Hurricane Conference",
    month :"May",
    lastDate:16,
    tooltipTitle:"Governor’s Hurricane...",
    date:`<p>Sun ,May  11, 2025 to <br> Fri, May 16,2025 </p>`,
    location: 'Palm Beach County Convention Center West Palm Beach, Florida',
    content: "The Governor’s Hurricane Conference focuses on hurricane planning ...",
    navlink:"https://domesticpreparedness.com/event/governors-hurricane-conference"
  },
  {
    title: "IAFC’s Community Risk Reduction  ...",
    month :"May",
    lastDate:15,
    tooltipTitle:"IAFC’s Community ...",
    date:`<p>Tue ,May 13, 2025 to<br> Thu, May 15, 2025 </p>`,
    location: 'Glendale, AZ',
    content: "The International Association of Fire Chief's (IAFC) Community Risk Reduction (CRR) Leadership Conference is geared specifically to the education and training needs of chief officers and other fire service managers […]",
    navlink:"https://domesticpreparedness.com/event/iafcs-community-risk-reduction-leadership-conference-2025"
  },
   {
    title: "Large Loss Mastery Training - Dallas",
    month :"May",
    lastDate:15,
    tooltipTitle:"Large Loss Mastery...",
    date:`<p>Tue,May 13, 2025 to <br> Thu, May 15, 2025</p>`,
    location: 'Arlington',
    content: "One of a kind training Large Loss Mastery Training course covers: Damage Assessment, Estimating, Critical Path Management, Scope of Work Creation...",
    navlink:"https://10times.com/e1d3-53x4-dxzg-k"
  },
  {
    title: "Secure360 Conference",
    month :"May",
    lastDate:15,
    tooltipTitle:"Secure360 Conference",
    date:`<p>Wed ,May 14, 2025 to  <br> Thu, May 15, 2025</p>`,
    location: 'Mystic Lake Center, Prior Lake, USA',
    content: "Secure360 is an all-encompassing experience that brings professionals...",
    navlink:"https://10times.com/secure360"
  },

{
    title: "Certified DevSecOps Engineer (ECDE) - EC-Council",
    month :"May",
    lastDate:16,
    tooltipTitle:"Certified DevSecOps",
    date:`<p> Mon ,May 12, 2025 to <br> Fri, May 16, 2025</p>`,
    location: 'Chicago',
    content: "EDRP provides professionals with a strong understanding of business continuity and disaster recovery principles, including conducting business impact",
    navlink:"https://10times.com/e1hf-xf17-gk2f-8"
  },
  {
    title: "National VOAD 2025 Conference",
    month :"May",
    lastDate:22,
    tooltipTitle:"National VOAD 2025...",
    date:`<p>Mon, May 19, 2025 to <br> Thu, May 22, 2025</p>`,
    location: 'Louisville, KY',
    content: "National Voluntary Organizations Active in Disaster (VOAD) was founded over 50 years ago in response to the challenges many disaster organizations experienced following Hurricane Camille, a Category 5 storm that […]",
    navlink:"https://domesticpreparedness.com/event/national-voad-2025-conference"
  },
  {
    title: "Texas Emergency Management ...",
    month :"May",
    lastDate:30,
    tooltipTitle:"Texas Emergency...",
    date:`<p>Tue,May 27, 2025 to <br> Fri ,May 30, 2025</p>`,
    location: 'Ft. Worth Conference Center',
    content: "The Conference attracts over 3,500 elected officials, first responders, emergency managers, and decision makers from across Texas. This event provides a valuable opportunity for access to the latest technology, exchange […]",
    navlink:"https://domesticpreparedness.com/event/texas-emergency-management-conference-4"
  },
  {
    title: "5×5 The Public Safety Innovation ...",
    month :"June",
    lastDate:5,
    tooltipTitle:"5×5 The Public Safety...",
    date:`<p>Tue,June 3, 2025 to <br>Thu ,June 5, 2025</p>`,
    location: 'Bellevue, WA',
    content: "The summit brings together public safety, academia, government, and industry to help design the future of first responder communications. Test the latest innovations in public safety communications, see what is",
    navlink:"https://domesticpreparedness.com/event/5x5-the-public-safety-innovation-summit"
  },
  {
    title: "International Hazardous Materials Response...",
    month :"June",
    lastDate:15,
    tooltipTitle:"International Hazardous...",
    date:`<p>Thu, June 12, 2025 to <br>Sun, June 15, 2025</p>`,
    location: 'Hilton Baltimore',
    content: "The International Association of Fire Chiefs’ Hazmat Conference provides the classroom, hands-on, and field trip-based training that covers all aspects of hazmat, including transportation, safety, gear, terrorism, weapons of mass […]",
    navlink:"https://domesticpreparedness.com/event/international-hazardous-materials-response-teams-conference-2025-2"
  },
  {
    title: "United States Conference of Mayors...",
    month :"June",
    lastDate:25,
    tooltipTitle:"United States Conference...",
    date:`<p> Thu, June 19, 2025 to <br> wed ,June 25, 2025</p>`,
    location: 'Tampa, FL',
    content: "The United States Conference of Mayors is the official non-partisan organization of cities with populations of 30,000 or more. There are over 1,400 such cities in the country today. Each […]",
    navlink:"https://domesticpreparedness.com/event/united-states-conference-of-mayors-93rd-annual-meeting"
  },
  {
    title: "2025 NVFC Training Summit",
    month :"June",
    lastDate:21,
    tooltipTitle:"2025 NVFC Training...",
    date:`<p> Fri, June 20, 2025  to <br> Sat, June 21, 2025</p>`,
    location: 'Salt Lake City, UT',
    content: "The 2025 National Volunteer Fire Council Training Summit offers classroom-based training and collaborative opportunities for emergency responders from across the United States. Attendees can choose from breakout sessions organized into […]",
    navlink:"https://domesticpreparedness.com/event/2025-nvfc-training-summit"
  },
  {
    title: "The National Sheriffs’ Association... ",
    month :"June",
    lastDate:26,
    tooltipTitle:"The National Sheriffs...’",
    date:`<p>Mon ,June 23 ,2025 to <br>Thu, June 26 , 2025</p>`,
    location: 'Fort Lauderdale, FL',
    content: "The National Sheriff's Association Annual Conference includes a trade show displaying products and equipment relevant to every facet of police work, jails, prisoner transport, and courtroom security. This event features […]",
    navlink:"https://domesticpreparedness.com/event/the-national-sheriffs-association-annual-conference"
  },
  {
    title: "International Symposium on Animal...",
    month :"June",
    lastDate:2,
    tooltipTitle:"International Symposium ...",
    date:`<p>Sat, June 28 , 2025 to <br>wed, July 2 , 2025</p>`,
    location: 'Stevens Point, WI',
    content: "The International Symposium on Managing Animal Mortalities is a triennial symposium focusing on collaborating and sharing information to advance sustainable practices regarding animal mortalities. The first one was held in […]",
    navlink:"https://domesticpreparedness.com/event/international-symposium-on-animal-mortality-management"
  },
   
 
  ]

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 5000, min: 2304},
      items: 5
    },
    largeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 2303, min: 1441 },
      items: 4
    },
    desktop: {
      breakpoint: { max: 1440, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const settings = {
    // dots: true,
    // slidesToScroll={1}
    // speed={500}
    // infinite: false ,
    // centerMode: true,
    arrows: true,
    lazyLoad: 'anticipated',
    centerPadding: "10px",
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    focusOnSelect : true,
    beforeChange: (current, next) => setCurrentSlide(next),
    responsive: [
      {
        breakpoint: 10000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots:false,
          arrows:true
        },
      },
      {
        breakpoint:  1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots:false,
          arrows:true
        },
      },
      {
        breakpoint:  999,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots:false,
          arrows:true
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots:false,
          arrows:true
        },
      },
      {
        breakpoint:700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:false,
          arrows:true,
          infinite:true
        },
      },
    ],
  };

  return (
    <div  className="events">
      <div  className="home-container-services">
      <Grid item xs={12} md={12} ls={12}  >
        <Box sx={{ paddingBottom:{xs:'15px',sm:"50px"} }}>
          <div>
            <h2
              style={{ textAlign: 'center' }}
              className="primary-font-bold-heading"
            >
              Upcoming Events
            </h2>
          </div>
          {/* <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        /> */}
          {/* <Carousel className="custom-carousel"
            responsive={responsive}
            arrows
            infinite
            style={{ paddingBottom: '20px'}}
          > */}
      
            <Slider
             {...settings}
             infinite= { remainingMonths(servicesCard).length >=3 ? true : false} 
              >
            { remainingMonths(servicesCard).map((item, i) => {
              return (
                <Item key={i} singleCard={item} />
              )
            })}
            </Slider>
       
          {/* </Carousel> */}
        </Box>
      </Grid>
      </div>
     </div>
  );
};
// function ResponsiveItem({ key, singleCard }) {
//   const navigate = useNavigate();
//   return (<Grid container sx={{marginLeft:'5px', marginTop: '5px', height: '360px' }}>
//     <Card key={key} sx={{':hover': { boxShadow:5  }}} className="event-card" >
//       <CardContent style={{
//         height: '300px',
//         marginBottom: "10px"
//       }}>
//         <Typography className="primary-font-bold4 card-title" style={{ textAlign: 'left', height: '53px', paddingTop: '10px' }} >
//           {singleCard.title}
//         </Typography>
//         <hr style={{ marginTop: "20px", marginBottom: "5px" }} className="event-hr" />
//         <Box
//           component="ul"
//           className="list-component"
//           aria-labelledby="category-a"
//           sx={{ pl: 2 }}
//         >

//           <div style={{ display: 'flex' }}>
//             <img src={calendar} alt="calendar" />
//             <Typography className="primary-font-normal-4" sx={{ paddingLeft: '18px' }}>
//               <span dangerouslySetInnerHTML={{ __html: singleCard.date ? singleCard.date : "" }} />
//             </Typography>
//           </div>

//           <div style={{ display: 'flex' }}>
//             <img src={location} alt="location" />
//             <Typography className="primary-font-normal-4" sx={{ paddingLeft: '18px' }}>
//               {singleCard.location}
//             </Typography>
//           </div>

//         </Box>
//         <div style={{marginTop:'15px'}} className="card-content-wrapper primary-font-normal-4">{singleCard.content}</div>
//       </CardContent>
//       <CardActions
//         // className="read-more"
//         // style={{
//         //   height: '60px',
//         //   background: '#FAFAFB 0% 0% no-repeat padding-box'
//         // }}
//         sx={{display:"flex",justifyContent:"center",background: '#FAFAFB 0% 0% no-repeat padding-box',height: '60px'}}
//       >
//         {/* <a className="read-more  primary-font-normal-4 " target="_blank" href={singleCard.navlink}> 
//         <b>View Event Details</b>
//         </a> */}
//         <b className="read-more  primary-font-normal-4 ">View Event Details</b>
//       </CardActions>
//     </Card>
//   </Grid>
//   )
// }

function Item({ key, singleCard }) {
  const navigate = useNavigate();
  return (<Grid container item  sx={{paddingTop:'10px', paddingBottom:'10px',"&.MuiGrid-root " :{justifyContent:"center"}}}
  // sx={{height: '360px' ,"&.MuiGrid-root " :{justifyContent:"center"}}}
  >
    <Card key={key} sx={{':hover': {boxShadow:5 }}} className="event-card">
      <CardContent style={{
        height: '300px',
        marginBottom: "10px"
      }}>
        <Typography className="primary-font-bold1 card-title" style={{ textAlign: 'left', height: '53px', paddingTop: '10px' }} >
          {singleCard.title}
        </Typography>
        <hr style={{ marginTop: "20px", marginBottom: "5px" }} className="event-hr" />
        <Box
          component="ul"
          className="list-component"
          aria-labelledby="category-a"
          sx={{ pl: 2 }}
        >

          <div style={{ display: 'flex' }}>
            <img src={calendar} alt="calendar" />
            <Typography className="event-calender-font" sx={{ paddingLeft: '18px' }}>
              <span dangerouslySetInnerHTML={{ __html: singleCard.date ? singleCard.date : "" }} />
            </Typography>
          </div>

          <div style={{ display: 'flex' }}>
            <img src={location} alt="location" />
            <Typography className="event-calender-font" sx={{ paddingLeft: '18px' }}>
              {singleCard.location}
            </Typography>
          </div>

        </Box>
        <div style={{marginTop:'15px'}} className="card-content-wrapper event-calender-font">{singleCard.content}</div>
      </CardContent>
      <CardActions
        // className="read-more"
        // style={{
        //   height: '60px',
        //   background: '#FAFAFB 0% 0% no-repeat padding-box'
        // }}
        sx={{display:"flex",justifyContent:"center",background: '#FAFAFB 0% 0% no-repeat padding-box',height: '60px'}}
      >
        <a className="read-more  event-calender-font" target="_blank" href={singleCard.navlink}> 
        <b>View Event Details</b>
        </a>
        {/* <b className="read-more  event-calender-font ">View Event Details</b> */}
      </CardActions>
    </Card>
  </Grid>
  )
}

export default Events;
